var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { CompaniesClient, SitesClient, DischargeClient, GetDischargeActivityQuery, ReportScheduleModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import { DatePresetOption } from "@/common/enums/date-preset";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
import moment from "moment";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const dischargesClient = new DischargeClient(window.apiUrl);
let DischargeActivityReportFilterVue = class DischargeActivityReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["W", "M", "3M", "Y", "All", "..."];
        this.dateFilterOption = "";
        this.defaultDateFilterOption = "M";
        this.companies = [];
        this.sites = [];
        this.companyId = null;
        this.siteId = null;
        this.startTime = new Date();
        this.endTime = new Date();
        this.minDischargeDuration = 15;
        this.reportByString = false;
    }
    created() {
        if (this.loginState.isPowerShield) {
            this.dateFilterOptions = ["Prev M", ...this.dateFilterOptions];
            this.defaultDateFilterOption = "Prev M";
        }
        this.dateFilterOption = this.defaultDateFilterOption;
        this.getLookups();
    }
    ;
    mounted() {
        this.loadReportScheduleQuery();
    }
    ;
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `Any company` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (this.areDatesInvalid) {
            console.error("Dates are invalid");
            return null;
        }
        let reportQuery = new GetDischargeActivityQuery({
            companyId: this.companyId,
            siteId: this.siteId,
            startDate: this.startTime ? DateHelper.convertToDate((this.startTime).toString()) : null,
            endDate: this.endTime ? DateHelper.convertToDate((this.endTime).toString()) : null,
            currentTimezoneOffset: moment().utcOffset(),
            startTimezoneOffset: this.startTime ? moment(this.startTime).utcOffset() : moment().utcOffset(),
            endTimezoneOffset: this.endTime ? moment(this.endTime).utcOffset() : moment().utcOffset(),
            dischargeMinSeconds: this.minDischargeDuration,
            breakByString: this.reportByString
        });
        return reportQuery;
    }
    ;
    exportToPdf() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            var query = this.getQuery();
            if (query == null)
                return;
            this.working = true;
            dischargesClient.downloadDischargeActivityAsPDF(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                let blob = new Blob([response.data], { type: 'application/pdf;base64' });
                let url = URL.createObjectURL(blob);
                var popUp = window.open(url, '_blank');
                if (popUp == null || typeof (popUp) == 'undefined') {
                    alert('Please disable your pop-up blocker and try again.');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, (ctx) => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            var query = this.getQuery();
            if (query == null)
                return;
            this.working = true;
            dischargesClient.downloadDischargeActivityAsCsv(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                DownloadUtil.handleFileDownload(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, (ctx) => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    ;
    onCompanyIdChanged() {
        if (!this.working)
            this.siteId = null;
    }
    setDefaultDates() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let dateRange = { start: this.startTime, end: this.endTime };
                switch (this.dateFilterOption) {
                    case "Prev M":
                        dateRange = DateHelper.getDateRange(DatePresetOption.PrevMonth);
                        break;
                    case "W":
                        dateRange = DateHelper.getDateRange(DatePresetOption.SevenDays);
                        break;
                    case "M":
                        dateRange = DateHelper.getDateRange(DatePresetOption.OneMonth);
                        break;
                    case "3M":
                        dateRange = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                        break;
                    case "Y":
                        dateRange = DateHelper.getDateRange(DatePresetOption.OneYear);
                        break;
                    case "All":
                        dateRange = { start: null, end: null };
                        break;
                }
                this.startTime = dateRange.start;
                this.endTime = dateRange.end;
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    ;
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryWithPeriod = Object.assign(Object.assign({}, reportQuery), { dateFilterOption: this.dateFilterOption });
        var queryString = JSON.stringify(queryWithPeriod);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.companyId = query.companyId;
            this.siteId = query.siteId;
            this.reportByString = query.breakByString;
            this.minDischargeDuration = query.dischargeMinSeconds;
            this.setFieldValue('minDischargeDuration', this.minDischargeDuration);
            if (query.dateFilterOption) {
                this.setDateFilterOption(query.dateFilterOption);
                // If custom dates were selected ("..."), restore the exact dates from the query
                if (query.dateFilterOption === "...") {
                    if (query.startDate) {
                        this.startTime = DateHelper.convertToDate(query.startDate);
                    }
                    if (query.endDate) {
                        this.endTime = DateHelper.convertToDate(query.endDate);
                    }
                }
            }
            else {
                let startTime = query.startDate ? DateHelper.convertToDate(query.startDate) : null;
                let endTime = query.endDate ? DateHelper.convertToDate(query.endDate) : null;
                if (startTime && endTime) {
                    var duration = moment.duration(moment(endTime).diff(moment(startTime)));
                    console.log("Report schedule duration in days: ", duration.asDays());
                    var days = duration.asDays();
                    if (days < 8)
                        this.setDateFilterOption("W");
                    else if (days < 32)
                        this.setDateFilterOption("M");
                    else if (days < 100)
                        this.setDateFilterOption("3M");
                    else
                        this.setDateFilterOption("Y");
                }
                else {
                    this.setDateFilterOption("All");
                }
            }
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `Any site` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    get areDatesInvalid() {
        if (!this.startTime || !this.endTime)
            return false;
        let startTime = DateHelper.convertToDate(this.startTime.toString());
        let endTime = DateHelper.convertToDate(this.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], DischargeActivityReportFilterVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _b : Object)
], DischargeActivityReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeActivityReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeActivityReportFilterVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("dateFilterOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], DischargeActivityReportFilterVue.prototype, "setDefaultDates", null);
DischargeActivityReportFilterVue = __decorate([
    Component({
        name: "DischargeActivityReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    minDischargeDuration: yup.number().integer().min(0).max(3600),
                })
            });
            const minDischargeDurationVal = defineInputBinds('minDischargeDuration');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                minDischargeDurationVal
            };
        }
    })
], DischargeActivityReportFilterVue);
export default DischargeActivityReportFilterVue;
